export default {
  namespaced: true,
  state: {
    authState: 'undefined1',
    tokens: {
      idToken: 'undefined2',
    },
    userDataKey: 'undefined3',
  },
  getters: {
    getAuthState(state) {
      return state.authState
    },
    getIdToken(state) {
      return state.tokens.idToken
    },
    getUserDataKey(state) {
      return state.userDataKey
    },
  },
  mutations: {
    updateState(state, val) {
      state.authState = val
    },
    updateIdToken(state, val) {
      state.tokens.idToken = val
    },
    updateUserDataKey(state, val) {
      state.userDataKey = val
    },
  },
}
